import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Form, Input } from "antd";
import "./style.scss";
import logo from "assets/cemlogo.png";
import { IForm } from "types";
import Swal from "sweetalert2";
import { LeftOutlined } from "@ant-design/icons";

export const RecoverPasswordPage = () => {
	const [canGo, setCanGo] = useState(false);
	const navigate = useNavigate();

	const handleLogin = (values: IForm) => {
		const { email } = values;
		Swal.fire({
			icon: "success",
			text: `Verfique o e-mail enviado para ${email} e siga os passos seguintes.`,
		}).then(() => navigate("/login"));
		const html = document.getElementsByTagName("html");
		html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
		document.body.classList.remove("swal2-shown", "swal2-height-auto");
	};

	return (
		<div className="login">
			<div className="login__container">
				<div className="login__container__header">
					<img src={logo} alt="logo" />
				</div>
				<div className="login__container__title">
					<button
						className="back"
						onClick={() => window.history.back()}
						style={{ cursor: "pointer" }}
					>
						Voltar
					</button>
					<LeftOutlined
						className="arrow"
						onClick={() => window.history.back()}
					/>
					<h1 className="title">Recuperação de Senha</h1>
				</div>
				<div className="login__container__form">
					<Form
						name="basic"
						onFinish={(values) => handleLogin(values)}
						onFinishFailed={(error) => console.log(error)}
						autoComplete="off"
					>
						<Form.Item
							name={"email"}
							rules={[
								{
									required: true,
									message: "E-mail necessário",
								},
							]}
						>
							<Input
								placeholder={"E-mail"}
								id="userinfo"
								onChange={(e) =>
									setCanGo(
										e.target.value !== "" && e.target.value.includes("@")
									)
								}
							/>
						</Form.Item>

						<Form.Item>
							<Button type="primary" htmlType="submit" disabled={!canGo}>
								Recuperar Senha
							</Button>
						</Form.Item>
					</Form>
				</div>
			</div>
		</div>
	);
};
